import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './CurrencySelector.css';
import React, { useRef, useContext, useState, useEffect, useMemo } from 'react';
import Select from 'react-select';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { getColorByTheme, getPageThemeColors, hexToRgb, get, canUseDOM } from '../../../utils';
import { LOCAL_STORAGE_APP_CURRENCY } from '../ListingOffersAndDeals';
import { BASE_SINGLE_SELECT_PROPS } from '../../../utils/constants';
var reactSelectSingleUiSettings = _objectSpread(_objectSpread({}, BASE_SINGLE_SELECT_PROPS), {}, {
  components: _objectSpread(_objectSpread({}, BASE_SINGLE_SELECT_PROPS.components), {}, {
    IndicatorsContainer: function IndicatorsContainer() {
      return null;
    }
  })
});
var CurrencySelector = function CurrencySelector(_ref) {
  var changeCurrency = _ref.changeCurrency,
    changeCurrencyName = _ref.changeCurrencyName,
    currencyName = _ref.currencyName,
    currencies = _ref.currencies,
    rtl = _ref.rtl,
    themeVariables = _ref.themeVariables;
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    highLightField = _useState2[0],
    setHighLightField = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    fieldOpened = _useState4[0],
    setFieldOpened = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isProcessing = _useState6[0],
    setIsProcessing = _useState6[1];
  var clickedFieldRef = useRef(false);
  var apiURL = process.env.STORYBOOK_MODE ? 'https://visitdubai.com' : get(sitecoreContext, 'origin');
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isVdsite = _useState8[0],
    setIsVdsite = _useState8[1];
  var colorSettings = useMemo(function () {
    if (themeVariables) {
      var values = Object.values(themeVariables);
      return {
        '--component-background-color': values[0],
        '--component-background-color-rgb': values[1],
        '--component-background-active-color': values[2],
        '--component-color': values[3]
      };
    }
    return {
      '--component-background-color': primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
      '--component-background-color-rgb': hexToRgb(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary, true),
      '--component-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
      '--component-color': getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
    };
  }, [themeVariables, isVdsite, primaryPageThemeColor, primaryActivePageThemeColor]);
  var options = useMemo(function () {
    return currencies.map(function (currency) {
      var currencyShort = get(currency, 'currencyId.jss.value');
      var icon = get(currency, 'icon.jss.value.src');
      return {
        label: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
          src: icon,
          alt: currencyShort,
          width: "25",
          height: "25"
        }), /*#__PURE__*/React.createElement("span", null, currencyShort)),
        value: currencyShort
      };
    });
  }, [currencies]);
  useEffect(function () {
    if (!currencyName) return;
    if (currencyName === 'AED') {
      changeCurrency(1);
    } else {
      setIsProcessing(true);
      var reqHeaders = new Headers();
      var requestOptions = {
        method: 'GET',
        headers: reqHeaders
      };
      var url = new URL("".concat(apiURL, "/api/currencyapi/exchangerates"));
      var queryString = new URLSearchParams({
        from: 'AED',
        to: currencyName
      });
      url.search = queryString.toString();
      fetch(url.toString(), requestOptions).then(function (response) {
        return response.status === 200 ? response.json() : null;
      }).then(function (data) {
        var responseReducedObj = Object.values(data)[0];
        changeCurrency(responseReducedObj.val);
        setIsProcessing(false);
      }).catch(function (error) {
        changeCurrencyName('AED');
        changeCurrency(1);
        localStorage.setItem(LOCAL_STORAGE_APP_CURRENCY, 'AED');
        console.error(error);
        setIsProcessing(false);
      });
    }
  }, [currencyName, apiURL, changeCurrencyName, changeCurrency]);
  useEffect(function () {
    if (canUseDOM) {
      if (!document.body.classList.contains('vdsite')) {
        setIsVdsite(false);
      }
    }
  }, []);
  if (!options.length) {
    return null;
  }
  var handleChange = function handleChange(event) {
    setFieldOpened(false);
    changeCurrencyName(event.value);
    localStorage.setItem(LOCAL_STORAGE_APP_CURRENCY, event.value);
  };
  var handleFocus = function handleFocus() {
    if (!clickedFieldRef.current) {
      setHighLightField(true);
    }
  };
  var handleMousedown = function handleMousedown() {
    clickedFieldRef.current = true;
    setFieldOpened(!fieldOpened);
  };
  var handleTouchstart = function handleTouchstart(e) {
    var dropListTouched = !!e.target.closest('.select-dropdown__menu');
    if (!dropListTouched) {
      setFieldOpened(!fieldOpened);
    }
  };
  var handleBlur = function handleBlur() {
    clickedFieldRef.current = false;
    setHighLightField(false);
    setFieldOpened(false);
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.which === 13 || e.which === 32) {
      setFieldOpened(!fieldOpened);
      if (!fieldOpened) {
        e.preventDefault();
      }
    }
    if (e.which === 27) {
      setFieldOpened(false);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    style: colorSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "\n      input-wrapper\n      ".concat(fieldOpened ? 'input-wrapper--opened' : '', "\n      ").concat(isProcessing ? 'input-wrapper--disabled' : '', "\n    ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-primary lr__dd",
    onMouseDown: handleMousedown,
    onTouchStart: handleTouchstart
  }, /*#__PURE__*/React.createElement(Select, _extends({}, reactSelectSingleUiSettings, {
    name: "dealsCurrenncySelector",
    id: "dealsCurrenncySelector",
    options: options,
    value: options.find(function (item) {
      return item.value === currencyName;
    }),
    className: "react-custom-select ".concat(highLightField ? 'react-custom-select--outlined' : ''),
    onChange: handleChange,
    onFocus: handleFocus,
    onMouseDown: handleMousedown,
    onKeyDown: handleKeyDown,
    onBlur: handleBlur,
    "aria-label": "Deals select currency",
    "aria-labelledby": "Deals select currency",
    menuIsOpen: fieldOpened
  })))));
};
export default CurrencySelector;
var commonStyles = "cppexqa";
var ltrStyles = "l1moz8o3";
var rtlStyles = "r1q6osd2";